import React, { useState, useEffect } from 'react';
import Layout from '../../../app/Layout';
import HeaderContent from '../General/HeaderContent';
import Breadcrumb from '../General/Breadcrumb';
import SpinnerLoading from '../../components/Spinners/SpinnerLoading';
import useSelectProyecto from '../../../hooks/useSelectProyectos';
import { useHistory } from 'react-router-dom';
import { Button } from 'react-bootstrap';

const Implementacion = () => {
  const [proyecto, SelectProyecto] = useSelectProyecto(null);
  const history = useHistory();

  const handleConsultar = () => {
    if (proyecto) {
      history.push(`/gestion-sesiones/${proyecto.id_proyecto}`);
    }
  };

  return (
    <Layout>
      <div className="Implementacion">
        <div className="Implementacion__container">
          <div className="Implementacion__head">
            <HeaderContent title="Gestión de Sesiones" icon="tasks" />
            <Breadcrumb
              link={[
                { url: '/inicio', nombre: 'Inicio', icon: 'fas fa-home' },
                { url: '/gestion-sesiones', nombre: 'Gestión de Sesiones' },
              ]}
            />
          </div>
          <div className="box p-3 mt-3">
            <div className="row">
              <div className="col-md-4">
                <label>Seleccionar Producto</label>
                <SelectProyecto />
              </div>
              <div className="col-md-2 d-flex align-items-end">
                <Button variant="primary" onClick={handleConsultar} disabled={!proyecto}>
                  Consultar
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Implementacion;
